import Icon from "~/components/shared/Icon";
import { Job } from "~/components/build/Show/lib/types";

interface Props {
  job: Job;
}

export const StackErrored = ({ job }: Props) => {
  if (!job.stackErrored) {
    return null;
  }

  return (
    <div className="mt-4 flex overflow-hidden rounded border border-red-500">
      <div className="flex w-8 flex-shrink-0 justify-center border-r border-red-500 bg-red-500 pt-4">
        <Icon icon="heroicons/16/solid/x-mark" className="h-4 w-4 text-white" />
      </div>

      <div className="flex-grow px-4 py-3">
        <h3 className="mb-2 mt-0 text-base">Agent stack error</h3>

        <p className="mb-3 mt-0">
          This job encountered errors in the agent stack that prevented it from running
          successfully.
        </p>

        <p className="m-0">
          Check the <strong>Timeline</strong> tab for more information.
        </p>
      </div>
    </div>
  );
};
